// extracted by mini-css-extract-plugin
export default {"wrap":"L3_bYF020t5FcTbAqd1A","title":"DcikC8M7FGWvoAqOjV8Z","title2":"InVLxTZbknyXifbMe7XG","text":"KGUaxVtNIM1giUCaYyoo"};